import React from 'react';
import { Flex, Text, Image } from 'rebass';
import notificationIcon from 'assets/icons/notification.png';
import colors from 'theme/colors';
import { EmployerContent, RecruiterContent } from '../content';
import { Notification } from '../../../types/notifications';
import BlockWrapper from './BlockWrapper';
import NotificationComponent from './NotificationComponent';
import useNotifications from '../hooks/useNotifications';

interface NotificationsProps {
  content: EmployerContent | RecruiterContent;
}

const Notifications: React.FC<NotificationsProps> = ({
  content,
}: NotificationsProps): JSX.Element => {
  const { notifications, unreadNotificationsCount } = useNotifications();

  return (
    <BlockWrapper mb={4}>
      <Flex style={{ width: '100%' }} flexDirection="column">
        <Flex>
          <Flex alignItems="flex-start">
            <Image src={notificationIcon} />
          </Flex>
          <Flex flexDirection="column" ml={1}>
            <Text fontSize="25px" fontWeight={6} lineHeight={1} mb={1}>
              {content.notifications.title}
            </Text>
          </Flex>
          {unreadNotificationsCount ? (
            <Text
              style={{ position: 'relative', top: -10, left: 5 }}
              color={colors.red}
              fontWeight="bold"
            >
              {unreadNotificationsCount} new
            </Text>
          ) : null}
        </Flex>
        <Flex style={{ marginLeft: 22 }}>
          {notifications.length ? (
            <Flex flexDirection="column" style={{ width: '100%' }}>
              {notifications.map((n: Notification) => (
                <NotificationComponent notification={n} key={n.id} />
              ))}
            </Flex>
          ) : (
            <Text fontSize="20px" fontWeight={5}>
              {content.notifications.subtitle}
            </Text>
          )}
        </Flex>
      </Flex>
    </BlockWrapper>
  );
};

export default Notifications;
